var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vehicle)?_c('TrackerLocation',{attrs:{"vehicle":_vm.vehicle}}):_c('div',{staticClass:"error"},[_c('h2',[_vm._v("Vehicle not found")]),_c('p',[_vm._v("The requested vehicle could not be found.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }